export const PaletteIcon = ({ className }: { className?: string }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clip-path="url(#hbfuo9nb0a)" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                <path
                    d="M8 14.667A6.667 6.667 0 0 1 8 1.334c1.768 0 3.464.632 4.714 1.757 1.25 1.126 1.953 2.652 1.953 4.243a3.333 3.333 0 0 1-3.333 3.333h-1.5a1.167 1.167 0 0 0-.934 1.867l.2.267a1.166 1.166 0 0 1-.933 1.866H8z"
                    strokeWidth="1.5"
                />
                <path
                    d="M9 4.667A.333.333 0 1 0 9 4a.333.333 0 0 0 0 .667zM11.667 7.333a.333.333 0 1 0 0-.667.333.333 0 0 0 0 .667z"
                    fill="currentColor"
                    strokeWidth="1.5"
                />
                <path d="M4.333 8.667a.333.333 0 1 0 0-.667.333.333 0 0 0 0 .667z" fill="currentColor" strokeWidth="2" />
                <path d="M5.667 5.333a.333.333 0 1 0 0-.667.333.333 0 0 0 0 .667z" fill="currentColor" strokeWidth="1.5" />
            </g>
            <defs>
                <clipPath id="hbfuo9nb0a">
                    <path fill="#fff" d="M0 0h16v16H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
